import { styled } from "@pigment-css/react";

/** Must be at least as wide as the widest date chip; a narrower column lets a long chip push its row's text out of line with the others. */
const DATE_COLUMN_WIDTH = "84px";

export const DateColumn = styled("div")({
  display: "flex",
  width: DATE_COLUMN_WIDTH,
  flexShrink: 0,

  "& > *": {
    width: "100%",
    justifyContent: "center",
  },
});

export const DatedListDivider = styled("div")(({ theme }) => ({
  height: "1px",
  backgroundColor: theme.managementView.colors.neutral[8],
  marginLeft: `calc(${DATE_COLUMN_WIDTH} + ${theme.managementView.spacing[16]})`,
  width: `calc(100% - ${DATE_COLUMN_WIDTH} - ${theme.managementView.spacing[16]})`,
}));
